/**
 * sizeRank に対応する名称 および サイズ基準
 *
 * ## サイズ基準
 * SS: 80cmまで
 * S: 120cmまで
 * A: 160cmまで
 * B: 200cmまで
 * C: 250cmまで
 * D: 300cmまで
 * E: 350cmまで
 * F: 400cmまで
 * G: 450cmまで
 */
export const yhcSizeRanks = {
  ss: { label: 'SS', min: 1, max: 80 },
  s: { label: 'S', min: 81, max: 120 },
  a: { label: 'A', min: 121, max: 160 },
  b: { label: 'B', min: 161, max: 200 },
  c: { label: 'C', min: 201, max: 250 },
  d: { label: 'D', min: 251, max: 300 },
  e: { label: 'E', min: 301, max: 350 },
  f: { label: 'F', min: 351, max: 400 },
  g: { label: 'G', min: 401, max: 99999 },
}

export type YhcSizeRank = keyof typeof yhcSizeRanks

/**
 * 3辺合計を元に sizeRank を計算する by yhcSizeRanks
 * @param sizeTotal
 */
export const calcSizeRank = (sizeTotal: number): YhcSizeRank => {
  return Object.keys(yhcSizeRanks).find((rank) => {
    const sizeRank = yhcSizeRanks[rank]
    return sizeTotal <= sizeRank.max
  }) as YhcSizeRank
}
